import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Heading, Text } from '@leroy-merlin-br/backyard-react-ui'

const sectionStyles = ({ theme }) => css`
  label: section;

  padding: ${theme.spacings.zetta} 0;

  background: ${theme.colors.background};
`

const sectionTitleStyles = ({ theme }) => css`
  color: ${theme.colors.n800};
  font-weight: ${theme.font.weight.regular};
`

const sectionTextStyles = ({ theme }) => css`
  color: ${theme.colors.n800};
`

const faqStyles = ({ theme }) => css`
  label: section__faq;

  position: relative;

  margin: ${theme.spacings.peta} 0;

  padding: ${theme.spacings.tera} ${theme.spacings.giga};

  background: ${theme.colors.white};
`

export const Section = styled('section')(sectionStyles)
export const SectionTitle = styled(Heading)(sectionTitleStyles)
export const SectionText = styled(Text)(sectionTextStyles)
export const Faq = styled('div')(faqStyles)
